<template>
  <div class="c-topCsvSchedule" v-if="previews.length !== 0">
    <div class="c-topCsvSchedule__title">ご入居までの主なスケジュール</div>
    <ul class="c-topCsvSchedule__cards">
      <li v-for="(preview, i) in previews" :key="`c-topCsvSchedule__card` + i">
        <a
          v-if="preview[2] !== ''"
          :href="preview[2]"
          :target="preview[3] === 'blank' ? '_blank' : ''"
          class="c-topCsvSchedule__cards__cardLink"
        >
          <div class="c-topCsvSchedule__cards__card">
            <div class="c-topCsvSchedule__cards__card__item">
              {{ preview[0] }}:
            </div>
            <div class="c-topCsvSchedule__cards__card__item">
              {{ preview[1] }}
            </div>
          </div>
        </a>
        <div v-else>
          <div class="c-topCsvSchedule__cards__card">
            <div class="c-topCsvSchedule__cards__card__item">
              {{ preview[0] }}:
            </div>
            <div class="c-topCsvSchedule__cards__card__item">
              {{ preview[1] }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import LoadCsvFromPublic from "../mixin/loadCsvFromPublic";

export default {
  mixins: [LoadCsvFromPublic],
  data: function() {
    return {
      previews: [],
    };
  },
  async mounted() {
    this.previews = await this.getCsv("schedule");
  },
};
</script>
